import styled from 'styled-components'
import { colors } from 'styles/colors'

export const Container = styled.div`
    position: relative;
    padding: 15px 24px;
    box-sizing: border-box;

    display: flex;

    &:not(:last-child):before {
        content: '';
        position: absolute;
        left: calc(100% - 95%);
        bottom: 0;
        height: 1px;
        width: 90%;
        border-bottom: 1px solid #f0f0f0;
    }
`

export const Trash = styled.button`
    width: 16px;
    height: 16px;

    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    flex-grow: 0;

    img {
        width: 16px;
    }
`

export const Header = styled.div`
    width: 100%;
    height: ${({ $isVertical }) => ($isVertical ? '50px' : '25px')};

    display: flex;
    justify-content: space-between;

    align-items: center;
`

export const Spacer = styled.div`
    width: 100%;

    display: flex;
    justify-content: space-between;
`

export const Card = styled.div`
    min-width: 40px;

    margin-right: 15px;
`

export const CardImage = styled.img`
    height: ${({ $isVertical }) => ($isVertical ? '50px' : '25px')};
    width: ${({ $isVertical }) => ($isVertical ? '30px' : '40px')};
`

export const Desc = styled.span`
    white-space: nowrap;
    font-size: 13px;
    font-weight: 900;
    color: #3b3c3c;

    text-transform: uppercase;
`

export const Content = styled.div`
    width: 100%;

    display: flex;
    flex-direction: column;

    & > * + * {
        margin-top: 10px;
    }
`

export const Group = styled.div`
    display: flex;
    flex-direction: column;

    & > * + * {
        margin-top: 3px;
    }
`

export const GroupLabel = styled.span`
    font-weight: 700;
    font-size: 14px;

    color: ${colors.darkGreen};
`

export const Label = styled.span`
    font-weight: 400;
    font-size: 14px;

    color: ${colors.silver2};
`

export const Value = styled.span`
    font-weight: 400;
    font-size: 14px;

    color: ${colors.black};
`
